import React from "react";

import Stats from "./Stats";
import TabsBox from "./TabsBox";
import Registration from "./Tabs/Registration";
import { useSelector } from "react-redux";
import FormsAndMoules from "./Tabs/FormsAndModules";
import Files from "./Tabs/Files";
import Compliance from "./Tabs/Compliance";
import Feed from "./Tabs/Feed";

const Home = () => {
  const { activeTab } = useSelector((state) => state.home);
  return (
    <div className="homeContainer">
      <Stats />
      <TabsBox />
      <div className="tabsContent">
        {activeTab === "Registration" && <Registration />}
        {activeTab === "Forms & Modules" && <FormsAndMoules />}
        {activeTab === "Files" && <Files />}
        {activeTab === "Compliance" && <Compliance />}
        {activeTab === "Feed" && <Feed />}
      </div>
    </div>
  );
};

export default Home;
